import { Injectable } from '@angular/core';
import { DadoSocioeconomicoDto } from '../../dtos/dado-socioeconomico';
import { CaqRequestService } from '../'
import { map, firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

interface ListDadoSocioeconomico {
  _embedded: {
    'dado-socioeconomico': DadoSocioeconomicoDto[];
  };
}

@Injectable({
  providedIn: 'root',
})
export class DadoSocioeconomicoService {
  public urlBase = `${environment.apiUrl}/dado-socioeconomico`;

  constructor(private caqRequestService: CaqRequestService) {}

  async pegaDadoSocioeconomico(): Promise<DadoSocioeconomicoDto[]> {
    return firstValueFrom(this.caqRequestService
      .get<ListDadoSocioeconomico>(this.urlBase)
      .pipe(map((response) => response._embedded['dado-socioeconomico'])));
  }
}
